import type {AdvancedSearchResponse} from '@api';

export function hasManuallyAddedOrigin(target: undefined | {origin?: string} | Array<{origin?: string}>): boolean {
    if (!target) {
        return false;
    }
    if (Array.isArray(target)) {
        return target.some((item) => item.origin === 'MANUALLY_ADDED');
    }
    return target.origin === 'MANUALLY_ADDED';
}

export function canResumeSelectionStep(advancedSearch: AdvancedSearchResponse): boolean {
    const {matching, selection} = advancedSearch;

    return (
        selection.length > 0 ||
        hasManuallyAddedOrigin(matching.formerCompanies) ||
        hasManuallyAddedOrigin(matching.keywords) ||
        hasManuallyAddedOrigin(matching.businessSector)
    );
}

export function canResumeCheckoutStep(advancedSearch: AdvancedSearchResponse): boolean {
    const {project, attachment} = advancedSearch;
    const originalDescriptionComingFromFileUploadIsEdited = Boolean(attachment && hasManuallyAddedOrigin(project.originalDescription));

    return (
        // Went to checkout step
        hasManuallyAddedOrigin(project.title) ||
        hasManuallyAddedOrigin(project.inferredDescription) ||
        originalDescriptionComingFromFileUploadIsEdited
    );
}

export function canEnterHighIntentSelectionStep(advancedSearch: AdvancedSearchResponse): boolean {
    const {matching, project} = advancedSearch;

    const hasDailyRate = matching.dailyRate?.dailyRate.value !== undefined && matching.dailyRate.dailyRate.value > 0;
    const hasDuration = project.duration?.value !== undefined && project.duration.value > 0;

    return hasDailyRate && hasDuration;
}

export function canEnterLowIntentCheckoutStep(advancedSearch: AdvancedSearchResponse): boolean {
    const {selection, project} = advancedSearch;

    const hasSelection = selection.length > 0;
    const isWithAssistance = project.expectedSourcingProcess === 'WITH_ASSISTANCE';
    const isDelegated = project.expectedSourcingProcess === 'DELEGATED';

    return hasSelection || isWithAssistance || isDelegated;
}
